import { initWaldo } from "waldo-web";
import posthog from "posthog-js";

export function startWaldo() {
  initWaldo({
    onConfusion: (event) => {
      safeCapture("waldo_confusion", {
        score: event.score,
        route: event.route,
        signals: event.trace.signals.map((s) => s.signal),
        hypothesis: event.verdict.hypothesis,
        severity: event.verdict.severity,
      });
    },
    onAnswer: (payload) => {
      safeCapture("waldo_answer", {
        question: payload.question,
        answer: payload.answer,
        route: payload.trace.route,
      });
    },
    // Feedback is saved by the SDK's built-in /waldo/feedback transport.
  });
}

function safeCapture(name, props) {
  try {
    if (posthog?.__loaded) posthog.capture(name, props);
  } catch {
    /* analytics is best-effort */
  }
}
